import React, { useEffect, useState, useContext } from "react";
import { FormattedMessage } from 'react-intl';

import { DeleteAccountContainer } from "./DeleteAccountStyled";

import { deleteInfluencerAccount } from "../../api/influencerApi";
import { deleteCompanyAccount } from "../../api/companyApi";
import { UserContext } from "../../context/userContext";
import { useNavigate } from "react-router-dom";
import Spinner from "../../components/Spinner/Spinner";
import Alert from "../../components/Alert/Alert";

export default function DeleteAccount() {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const { setUserToken, setUserType } = useContext(UserContext);
    const [showAlertError, setShowAlertError] = useState(false);

    const valores = window.location.search;
    const urlParams = new URLSearchParams(valores);

    //Accedemos a los valores
    let userType = urlParams.get('userType');
    let userToken = urlParams.get('env');

    useEffect(() => {

        if (userType === 'influencer') {
            deleteInfluencerAccount({ token: userToken }).then((response) => {

                if (response.status === 200) {
                    localStorage.removeItem('fluincrToken');
                    localStorage.removeItem('fluincrUser');
                    sessionStorage.removeItem('fluincrToken');
                    sessionStorage.removeItem('fluincrUser');
                    setUserToken(null);
                    setUserType('');
                    setIsLoading(false);
                    navigate('/');
                } else if (response.status === 403) {
                    setIsLoading(false);
                    setShowAlertError(true)
                }

            })
        } else {
            deleteCompanyAccount({ token: userToken }).then((response) => {

                if (response.status === 200) {
                    localStorage.removeItem('fluincrToken');
                    localStorage.removeItem('fluincrUser');
                    sessionStorage.removeItem('fluincrToken');
                    sessionStorage.removeItem('fluincrUser');
                    setUserToken(null);
                    setUserType('');
                    setIsLoading(false);
                    navigate('/');
                } else if (response.status === 403) {
                    setIsLoading(false);
                    setShowAlertError(true)
                }

            })
        }
    }, [userType, userToken])

    return (
        <DeleteAccountContainer>
            {/* <p>Delete account</p> */}
            {(isLoading) && (<Spinner />)}

            {(showAlertError) && (<Alert
                title={<FormattedMessage id="alert_error_network_title" defaultMessage="Error" />}
                text={<FormattedMessage id="delete_error" defaultMessage="Usuario no existe" />}
                setShowAlert={setShowAlertError}
                confirmText={<FormattedMessage id="footer_links_1_text_1" defaultMessage="Home" />}
                onConfirm={() => { navigate('/'); }}
            />)}
        </DeleteAccountContainer>
    )
}